module.exports = __webpack_public_path__ + "static/media/icon_factory_module.d664a900.svg";